import { validateTidalLicense } from "../../../base/index.js";
import "./editor.tidal.theme.js";
import { EditorFooterAction } from "./EditorFooterAction.js";
import { EditorFooterContent } from "./EditorFooterContent.js";
import { EditorProvider } from "./EditorProvider.js";
import { editorClasses } from "./classes.js";
validateTidalLicense();
export {
  EditorProvider as Editor,
  EditorFooterAction,
  EditorFooterContent,
  editorClasses
};
//# sourceMappingURL=index.js.map
